import Vue from 'vue';
import { copyWithToast } from '@/utils/copyUtils';
import { generateSessionFolderPath, generateSessionDisplayPath } from '@/utils/pathUtils';
import { formatSessionTotalLines, formattedCreatedAt, formatSessionInfoHumanTimeAgo, hasGems, isFromToday } from '@/utils/sessionFormatters';
export default Vue.extend({
    name: 'SessionListCards',
    props: {
        sessions: { type: Array, required: true },
        highlightedSessionId: { type: String, default: null }
    },
    computed: {
        sortedSessions() {
            return [...this.sessions].sort((a, b) => new Date(b.createdAt).getTime() - new Date(a.createdAt).getTime());
        }
    },
    methods: {
        goToSession(id) {
            // Navigate to the SessionView route, ensuring it's registered in Vue Router
            this.$router.push({ name: 'session', params: { id } });
        },
        // Use imported formatters from sessionFormatters.ts
        formatSessionTotalLines,
        hasGems,
        formattedCreatedAt,
        formatSessionInfoHumanTimeAgo,
        isFromToday,
        async copySessionPath(session) {
            try {
                const folderPath = generateSessionFolderPath(session);
                const displayPath = generateSessionDisplayPath(session);
                await copyWithToast(folderPath, `folder path ${displayPath}`);
                // Show toast notification
                this.$emit('show-toast', `Copied folder path: ${displayPath}`);
            }
            catch (error) {
                this.$emit('show-toast', `Copy failed: ${error}`);
            }
        }
    }
});
